import { render } from "./TableBoard.vue?vue&type=template&id=535a67fe&scoped=true"
import script from "./TableBoard.vue?vue&type=script&lang=js"
export * from "./TableBoard.vue?vue&type=script&lang=js"

import "./TableBoard.vue?vue&type=style&index=0&id=535a67fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-535a67fe"]])

export default __exports__